import { render, staticRenderFns } from "./ShipmentDetail.vue?vue&type=template&id=90552d54&scoped=true"
import script from "./ShipmentDetail.vue?vue&type=script&lang=js"
export * from "./ShipmentDetail.vue?vue&type=script&lang=js"
import style0 from "./ShipmentDetail.vue?vue&type=style&index=0&id=90552d54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90552d54",
  null
  
)

export default component.exports